/* Lege staat als één rustige tekstregel (quick wins 6 okt 2026): geen illustratie, geen vet. */

.empty {
  padding: var(--space-4) 0;
  text-align: start;
}

.compact {
  padding: var(--space-2) 0;
}

.heading {
  margin: 0 0 var(--space-2);
  color: var(--text);
  font-size: var(--text-xl);
  font-weight: 600;
  line-height: var(--line-tight);
}

.line {
  margin: 0;
  font-size: var(--b-text-body, 16px);
  font-weight: 400;
  line-height: var(--line-normal);
}

.title {
  color: var(--text);
}

.body {
  color: var(--text-muted);
}

.action {
  margin-top: var(--space-3);
}
